import { Fork, Invoke, nextPointer } from '@swf/components/StarsWizard/Flow';

import RMFAddress from '../../components/RMFAddress/RMFAddress';
import RMFDepositLimit from '../../components/RMFDepositLimit/RMFDepositLimit';
import RMFLegalName from '../../components/RMFLegalName/RMFLegalName';
import RMFPhone from '../../components/RMFPhone/RMFPhone';
import RMFPlayerFundsProtection from '../../components/RMFPlayerFundsProtection/RMFPlayerFundsProtection';
import RMFSummaryScreen from '../../components/RMFSummaryScreen/RMFSummaryScreen';
import RMFVerification from '../../components/RMFVerification/RMFVerification';
import useRMFBaseSteps from '../useRMFBaseSteps';

import { Guard } from './../useRmfGuards';
import { Service } from './../useRmfServices';

const useRmfUKBaseSteps = () => {
  const retryMarker = {
    name: 'retryMarker',
    after: { 0: nextPointer }
  };
  const { forkRmfExit } = useRMFBaseSteps();
  const forkVerification = new Fork(
    Guard.RecheckUserFlags,
    [RMFVerification, forkRmfExit],
    [forkRmfExit]
  );

  const invokeRetryEnableRealMoneyFlag = new Invoke(Service.RmfRetryInvokeRealMoneyOk, retryMarker);

  const invokeRetryDataSave: Invoke = new Invoke(
    Service.RmfRetryUserDataSave,
    invokeRetryEnableRealMoneyFlag
  );

  const forkSummaryScreen: Fork = new Fork(
    Guard.IsRetryScreenEnabled,
    [RMFSummaryScreen, invokeRetryDataSave],
    [RMFVerification]
  );

  const invokeDepositLimitSave: Invoke = new Invoke(
    Service.RmfDepositLimitSave,
    RMFPlayerFundsProtection,
    RMFDepositLimit
  );
  const forkRetryScreen = new Fork(Guard.CheckUserFlags, [forkSummaryScreen], [forkRmfExit]);

  const forkEKYCErrorHandling = new Fork(
    Guard.CheckEKYCRetry,
    [forkRetryScreen],
    [forkVerification]
  );

  const forkEKYCFailCheck = new Fork(
    Guard.CheckEKYCFailed,
    [forkEKYCErrorHandling],
    [forkVerification]
  );
  const invokeEnableRealMoneyFlag = new Invoke(Service.RmfEnableRealMoneyFlag, forkEKYCFailCheck);
  const invokeUserDataSave = new Invoke(Service.RmfUserDataSave, invokeEnableRealMoneyFlag);

  const invokeMobilePhoneSave = new Invoke(Service.RmfMobilePhoneSave, RMFLegalName, RMFPhone);
  const invokeAddressSave = new Invoke(Service.RmfAddressSave, RMFDepositLimit, RMFAddress);

  return {
    forkVerification,
    invokeRetryEnableRealMoneyFlag,
    invokeRetryDataSave,
    forkSummaryScreen,
    invokeDepositLimitSave,
    forkRetryScreen,
    invokeAddressSave,
    invokeEnableRealMoneyFlag,
    invokeUserDataSave,
    invokeMobilePhoneSave,
    forkEKYCFailCheck,
    retryMarker
  };
};

export default useRmfUKBaseSteps;
